import axios from 'axios'
// import { Notification, MessageBox, Message } from 'element-ui'
// import store from '@/store'
import { getToken } from '@/utils/auth'
// import errorCode from '@/utils/errorCode'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: "/api",
  // 超时
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  // const isToken = (config.headers || {}).isToken === false
  if (window.localStorage.getItem("user")) {

    config.headers['authorization'] = 'Bearer ' + window.localStorage.getItem("user") // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  // const message = errorCode[code] || res.data.msg || errorCode['default']
  if (code === 401) {
    let isApp = labor.isApp();
    if (isApp) {
      let users = JSON.parse(sessionStorage.getItem("userInfo"));
      axios.post("/api/login/qlgh", users)
        .then((ress) => {
          if (ress.data.token) {
            let token = ress.data.token;
            window.localStorage.setItem("user", token);
            let userId = ress.data.userId;
            window.localStorage.setItem("userId", userId);
            window.location.reload();
          }
        })
        .catch(() => { })
    } else {
      let userName = window.localStorage.getItem("userName");
      let password = window.localStorage.getItem("password");
      axios.post("/api/login/h5", { phone: userName, password: password })
        .then((ress) => {
          if (ress.data.token) {
            let token = ress.data.token;
            window.localStorage.setItem("user", token);
            let userId = ress.data.userId;
            window.localStorage.setItem("userId", userId);
            window.location.reload();
          }
        })
        .catch(() => { })
    }
  } else if (code === 500) {
    // Message({
    //   message: message,
    //   type: 'error'
    // })
    // return Promise.reject(new Error(message))
	return res.data
  } else {
    return res.data
  }
},
  error => {
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service
